import './add.scss';
import { useEffect, useState } from 'react';
import { ConfigProvider, message, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Enum, PaginationList } from 'core/domain';
import { AddBalancerTransaction } from 'core/domain/balancer-transaction/balancer-transaction';
import { deleteCommaSperator, digitSperator } from 'core/utils/decimalExtentions';
import { addBalancerTransaction } from 'core/repositories/balancer-transaction';
import { Page } from 'components/page/page';
import { Input, inputType } from 'components/input/input';
import { Button } from 'components';
import { buttonType } from 'components/button/button';
import { getOrderSides } from 'core/repositories/orders';

const initialFilters = {
    side: {
        id: -1,
        title: 'سمت معامله',
    },
};

export const AddBalancerTransactionPage = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<AddBalancerTransaction>({
        onPrice: 0,
        amount: 0,
        side: 1,
        symbol: 'انتخاب ارز',
    });
    const [orderSides, setOrderSides] = useState<Enum[]>([initialFilters.side]);

    const navigate = useNavigate();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        console.log('name:', name, 'value:', value);
        setFormData((prev) => ({
            ...prev,
            [name]: deleteCommaSperator(value),
        }));
    };

    const handleSubmit = async () => {
        await addBalancerTransaction(
            setLoading,
            {
                ...formData,
                amount: Number(deleteCommaSperator(formData.amount)),
                onPrice: Number(deleteCommaSperator(formData.onPrice)),
            },
            () => {
                message.success('تراکنش با موفقیت افزوده شد.');
                navigate(-1);
            },
        );
    };

    useEffect(() => {
        getOrderSides(setLoading, setOrderSides);
    }, []);

    return (
        <Page title="افزودن تراکنش" className="pmx-add-balancer-transaction">
            <ConfigProvider theme={{ token: { borderRadius: 20 } }}>
                <Select
                    disabled={loading}
                    loading={loading}
                    value={formData.side}
                    onChange={(value) => setFormData({ ...formData, side: value })}
                    style={{ width: '100%', borderRadius: 20 }}
                >
                    {orderSides.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                            {item.title}
                        </Select.Option>
                    ))}
                </Select>

                <Select
                    value={formData.symbol}
                    onChange={(value) => setFormData({ ...formData, symbol: value })}
                    style={{ width: '100%', borderRadius: 20 }}
                    placeholder="نماد را انتخاب کنید"
                >
                    <Select.Option value="UUSD">UUSD (یوتوپیا)</Select.Option>
                    <Select.Option value="USDT">USDT (تتر)</Select.Option>
                </Select>
            </ConfigProvider>

            <Input
                type={inputType.text}
                name="onPrice"
                value={digitSperator(formData.onPrice)}
                onChange={handleChange}
                label="قیمت:"
                placeholder="قیمت را وارد کنید"
            />

            <Input
                type={inputType.text}
                name="amount"
                value={digitSperator(formData.amount)}
                onChange={handleChange}
                label="مقدار:"
                placeholder="مقدار را وارد کنید"
            />

            <Button
                type={buttonType.success}
                loading={loading}
                disabled={
                    loading ||
                    !formData.amount ||
                    !formData.onPrice ||
                    !formData.symbol ||
                    formData.symbol === 'انتخاب ارز' ||
                    formData.side === -1
                }
                onClick={handleSubmit}
                text={'افزودن تراکنش'}
            />
        </Page>
    );
};
